import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const ErrorMessageWrapper = styled.div`
  position: absolute;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  top: ${(props) => (props.showError ? "116px" : "-125px")};
  border-bottom: 1px solid #eb5757;
  left: 60px;
  background: #ee9595;
  color: #fff;
  width: calc(100% - 60px);
  height: 60px;
  z-index: 1;
  transition: 0.1s ease-in-out;

  ${mediaMaxWidth.tablet`
    left: 0;
    width: 100%;
    padding: 0 15px;
  `}
`;

export const Emoji = styled.div``;

export const ErrorMessageText = styled.div`
  padding: 0 15px;
  color: #111111;
  font-weight: 500;
  font-size: 1.1em;
  letter-spacing: 0.015em;
  text-align: center;
  position: absolute;
  left: 55px;

  ${mediaMaxWidth.tablet`
    font-size: 0.9em;
    position: relative;
    left: unset;
  `}
`;

export const CloseErrorButton = styled.span`
  font-size: 1.5em;
  transition: 0.1s ease-in-out;

  &:hover {
    color: #333;
  }

  &:focus {
    outline: none;
  }

  ${mediaMaxWidth.tablet`
    font-size: 1.3em;
  `}
`;
